//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "ScheduleCalendarMobileItem",
  components: {
    Button: () => import("@/components/common/Button"),
  },
  props: {
    time: {
      type: String,
      default: () => '',
    },
    title: {
      type: String,
      default: () => '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    items_remain: {
      type: Number,
      default: () => 0,
    },
    price: {
      type: String,
      default: () => '',
    },
    status: {
      type: String,
      default: () => '',
    }
  },
  computed: {
    ...mapGetters({
      bookingTerms: 'schedule-calendar/bookingTerms',
      cancellationTerms: 'schedule-calendar/cancellationTerms',
      context: 'schedule-calendar/context',
      smRegistered: 'schedule-calendar/smRegistered',
      agency: 'schedule-calendar/agency',
      entity: 'schedule-calendar/entity',
      entityTitle: 'schedule-calendar/title',
      currentDay: 'schedule-calendar/currentDay',
      id: 'schedule-calendar/id',
      logged: 'user/logged',
      isProtectedAreas: "excursion/protectedAreas",
    }),
    showProtectedAreasButton() {
      if (this.$config?.pages?.ExcursionView?.components.ProtectedAreasButton) {
        return true
      } else {
        return false
      }
    },
    showButton() {
      if (this.isProtectedAreas && this.status === 'active') {
        return false
      } else {
        return true
      }
    },
    buttonText() {
      return this.status === 'available' ?
        this.$t('components.schedule-calendar.item.buy') :
        this.$t('components.schedule-calendar.item.to-order')
    },
    tariffs() {
      return this.context.filter(tariff => tariff.time === this.time)
        .filter(tariff => tariff.status === this.status)
    }
  },
  methods: {
    login() {
      if (!this.isProtectedAreas) {
        this.$cookies.set('$openPopupOrder', JSON.stringify({
          bookingTerms: this.bookingTerms,
          cancellationTerms: this.cancellationTerms,
          time: this.time,
          status: this.status,
          tariffs: this.tariffs,
          smRegistered: this.smRegistered,
          agency: {
            fullName: this.agency?.legal_information?.fullName,
            inn: this.agency?.legal_information?.inn,
            ogrn: this.agency?.legal_information?.ogrn,
            sm_registered: this.agency?.sm_registered,
          },
          entity: this.entity,
          date: this.currentDay,
          title: this.entityTitle,
          id: this.id,
        }), {
          path: '/',
          maxAge: 60 * 60 * 24 * 7
        })
      } else {
        this.$cookies.set('$openPupUpForProtectedAreas', JSON.stringify(
          {
            date: this.currentDay,
            title: this.entityTitle,
            time: this.time,
            tariffs: this.tariffs,
            agency: {
              fullName: this.agency?.legal_information?.fullName,
              inn: this.agency?.legal_information?.inn,
              ogrn: this.agency?.legal_information?.ogrn,
            },
          }
        ), {
          path: '/',
          maxAge: 60 * 60 * 24 * 7
        })
      }
    },

    width() {
      const width = () => {
        switch (this.media) {
          case "sm": {
            return "100%";
          }
          case "md": {
            return "100%";
          }
          default: {
            return "632px";
          }
        }
      };
    },

    openPopupProtectedAreas() {
      if (this.logged) {
        if (!this.isProtectedAreas) {
          this.$openPopupOrder({
            bookingTerms: this.bookingTerms,
            cancellationTerms: this.cancellationTerms,
            time: this.time,
            status: this.status,
            tariffs: this.tariffs,
            smRegistered: this.smRegistered,
            agency: {
              fullName: this.agency?.legal_information?.fullName,
              inn: this.agency?.legal_information?.inn,
              ogrn: this.agency?.legal_information?.ogrn,
              sm_registered: this.agency?.sm_registered,
            },
            entity: this.entity,
            date: this.currentDay,
            title: this.entityTitle,
            id: this.id,
          })
        } else {
          const options = {
            date: this.currentDay,
            title: this.entityTitle,
            time: this.time,
            tariffs: this.tariffs,
            agency: {
              fullName: this.agency?.legal_information?.fullName,
              inn: this.agency?.legal_information?.inn,
              ogrn: this.agency?.legal_information?.ogrn,
            },
          }
          this.$openPupUpForProtectedAreas(options)
        }
      } else {
        this.login()
      }
    },

    openPopup() {
      if (this.logged) {
        this.$openPopupOrder({
          bookingTerms: this.bookingTerms,
          cancellationTerms: this.cancellationTerms,
          time: this.time,
          status: this.status,
          tariffs: this.tariffs,
          smRegistered: this.smRegistered,
          agency: {
            fullName: this.agency?.legal_information?.fullName,
            inn: this.agency?.legal_information?.inn,
            ogrn: this.agency?.legal_information?.ogrn,
            sm_registered: this.agency?.sm_registered,
          },
          entity: this.entity,
          date: this.currentDay,
          title: this.entityTitle,
          id: this.id,
        })
      } else {
        this.login()
      }
    },
  }
}
